import React from 'react';
import classNames from 'classnames';

import Toggle from 'components/partials/toggle/toggle';
import Select from 'components/partials/select/select';

export interface YearOption {
  value: number;
  label: string;
}

export const generateYearOptions = ({
  futureYears,
  pastYears,
}: {
  futureYears: number;
  pastYears: number;
}): YearOption[] => {
  const currentYear = new Date().getFullYear();
  const range = {
    start: currentYear + futureYears,
    end: currentYear - pastYears,
  };

  const totalYears = range.start - range.end + 1;

  return Array.from({ length: totalYears }, (_, index) => {
    const year = range.start - index;

    return {
      value: year,
      label: String(year),
    };
  });
};

interface GoalsFiltersProps {
  showOnlyDefined: boolean;
  setShowOnlyDefined: (value: boolean) => void;
  selectedYear: string | number;
  setSelectedYear: (value: number | string) => void;
  customClass?: string;
}

const GoalsFilters = ({
  showOnlyDefined,
  setShowOnlyDefined,
  selectedYear,
  setSelectedYear,
  customClass = '',
}: GoalsFiltersProps): React.JSX.Element => {
  const years = generateYearOptions({ futureYears: 3, pastYears: 2 });

  return (
    <div className={classNames('flex items-center mb-4', customClass)}>
      <Select<YearOption>
        options={years}
        value={years.find((year) => year.value === Number(selectedYear))}
        onChange={(option) => {
          if (option && !Array.isArray(option)) {
            setSelectedYear(option.value);
          }
        }}
        selectWrapperClass="!w-28 mr-4"
        extraBasicStyles={{ padding: 0, height: '2' }}
        aria-label="Select year"
        data-testid="fiscal-year-select"
      />
      <Toggle
        onToggleChange={setShowOnlyDefined}
        isToggleOn={showOnlyDefined}
        toggleText="Show Only Defined Goals"
        data-testid="goals-matrix-filters-toggle"
      />
    </div>
  );
};

export default GoalsFilters;
